var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPauseVoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 40,
    rx: 20,
    fill: "#F2F2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0833 19.9997C18.0833 16.2677 18.0833 14.4017 19.2426 13.2424C20.402 12.083 22.268 12.083 25.9999 12.083C29.7319 12.083 31.5978 12.083 32.7572 13.2424C33.9166 14.4017 33.9166 16.2677 33.9166 19.9997C33.9166 23.7316 33.9166 25.5976 32.7572 26.757C31.5978 27.9163 29.7319 27.9163 25.9999 27.9163C22.268 27.9163 20.402 27.9163 19.2426 26.757C18.0833 25.5976 18.0833 23.7316 18.0833 19.9997Z",
    stroke: "#242428",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPauseVoice);
export default __webpack_public_path__ + "static/media/ic-pause-voice.d7e9c0471f1106063038930cc9d862a6.svg";
export { ForwardRef as ReactComponent };